import styled from "styled-components";

const CheckboxLabel = styled.label`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;

  input {
    width: 17px;
    height: 17px;
    accent-color: var(--color-main);
    cursor: pointer;
  }
`;

const ShipmentSelectionCheckbox = ({checked, onChange, shipmentId}) => (
  <CheckboxLabel onClick={(event) => event.stopPropagation()} title="Sevkiyatı seç">
    <input
      type="checkbox"
      checked={checked}
      aria-label={`${shipmentId} numaralı sevkiyatı seç`}
      onChange={() => onChange(shipmentId)}
    />
  </CheckboxLabel>
);

export default ShipmentSelectionCheckbox;
